import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { WriteLockBanner } from '@/components/Ams/shared/WriteLockBanner'
import { DaypartingPage } from '@/components/Dayparting/DaypartingPage'
import {
  daypartingSearchSchema,
  withoutDaypartingSearchDefaults,
} from '@/components/Dayparting/search'

/**
 * Wiring only. The schema lives beside the page in `search.ts`; the write-lock
 * banner is the AMS pages' own, composed here because domains do not import
 * each other.
 */
export const Route = createFileRoute('/_app/marketing/dayparting/')({
  validateSearch: daypartingSearchSchema,
  component: DaypartingRoute,
})

function DaypartingRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <DaypartingPage
      banner={<WriteLockBanner />}
      search={search}
      onSearchChange={(next) =>
        void navigate({
          search: (current) => withoutDaypartingSearchDefaults({ ...current, ...next }),
          replace: true,
        })
      }
    />
  )
}
